/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {action as ɵb,actionInternal as ɵa,computed as ɵc,observable as ɵd} from './lib/mobx-angular/mobx-proxy';
export {TreeMobxAutorunDirective as ɵe} from './lib/mobx-angular/tree-mobx-autorun.directive';